import { LitElement, html, nothing } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { EmbeddedHost } from '../shared/embedded-host.js';
import './sdb-composition-player-header.js';

@customElement('sdb-embedded-composition-player-header')
class SdbEmbeddedCompositionPlayerHeader extends EmbeddedHost(LitElement) {

    @property({ type: String })
    accessor catalogName;

    @property({ type: String })
    accessor sessionId;

    @property({ type: String })
    accessor type;

    @property({ type: Boolean })
    accessor preview;

    @property({ type: Boolean })
    accessor startDisabled = false;

    @property({ type: Boolean })
    accessor hideHeaderButtons = false;

    @property({ type: Boolean })
    accessor resetDisabled = false;

    @property({ type: Boolean })
    accessor resetHidden = false;

    @property({ type: Boolean })
    accessor light = false;

    @property({ type: Boolean })
    accessor small = false;

    @property({ type: Boolean })
    accessor compressed = false;

    isReady(state) {
        return super.isReady(state) && !!this.compositionId;
    }

    render() {
        if (!this.ready) {
            return nothing;
        }

        return html`
            <sdb-composition-player-header
                compositionId=${this.compositionId}
                sessionId=${this.sessionId}
                catalogName=${this.catalogName}
                type=${this.type}
                ?preview=${this.preview}
                ?startDisabled=${this.startDisabled}
                ?resetDisabled=${this.resetDisabled}
                ?resetHidden=${this.resetHidden}
                ?light=${this.light}
                ?small=${this.small}
                ?hideHeaderButtons=${this.hideHeaderButtons}
                ?compressed=${this.compressed}>
            </sdb-composition-player-header>
        `;
    }
}
